import React from 'react';
import { StepProps, Steps as AntdSteps, StepsProps } from 'antd';
import styled from '@emotion/styled';

const StyledSteps = styled(AntdSteps)``;
const StyledStep = styled(AntdSteps.Step)`
  .ant-steps-item-title {
    font-size: 12px;
    font-weight: 500;
    line-height: 14px;
    letter-spacing: 0em;
    text-align: center;
  }
  &.ant-steps-item-active {
    .ant-steps-item-title {
      color: #1890ff !important;
    }
  }
`;
const Steps = (props: StepsProps) => {
  return <StyledSteps {...props}></StyledSteps>;
};

const Step = (props: StepProps) => {
  return <StyledStep {...props}></StyledStep>;
};

Steps.Step = Step;

export default Steps;
